import HexRadio from './src/index.vue'

HexRadio.install = function (Vue) {
  Vue.component(HexRadio.name, HexRadio);
}

export default HexRadio;



// WEBPACK FOOTER //
// ./packages/components/radio/index.js